import moment from 'moment-timezone';

export const timezones = moment.tz.names()
    .filter(name => name.includes('US') || name.includes('Australia'));
